import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ConfigProvider } from './contexts/ConfigContext';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout/Layout';
import ConfigurationPage from './pages/ConfigurationPage';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import JobsPage from './pages/JobsPage';
import JobDetailPage from './pages/JobDetailPage';
import CreateJobPage from './pages/CreateJobPage';
import ResumeManagementPage from './pages/ResumeManagementPage';
import CandidateMatchingPage from './pages/CandidateMatchingPage';
import ProtectedRoute from './components/Auth/ProtectedRoute';

function App() {
  return (
    <ConfigProvider>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/config" element={<ConfigurationPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/jobs" 
              element={
                <ProtectedRoute>
                  <JobsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/job/:jobId" 
              element={
                <ProtectedRoute>
                  <JobDetailPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/create-job" 
              element={
                <ProtectedRoute>
                  <CreateJobPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/resume-management" 
              element={
                <ProtectedRoute>
                  <ResumeManagementPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/candidate-matching" 
              element={
                <ProtectedRoute>
                  <CandidateMatchingPage />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </Layout>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
